<template>
    <div class="btn-details" :class="{ active }" @click="$emit('click')">
        <span class="text-sm font-weight-normal">
            Szczegóły
        </span>

        <a-icon
            class="btn-details__chevron ml-0"
            icon="Chevron"
        />
    </div>
</template>

<script>
export default {
    props: {
        active: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss">
.btn-details {
    cursor: pointer;
    display: flex;
    align-items: center;
    user-select: none;

    &.active {
        .btn-details__chevron {
            transform: rotate(90deg);
        }
    }

    &__chevron {
        transition: 0.3s ease-in-out;
        transform: rotate(-90deg);
    }
}
</style>